module.exports = __webpack_public_path__ + "static/media/cases_3d_04b.6970393e.jpg";